module.exports = __webpack_public_path__ + "static/media/photo6.5fc24182.jpg";